import React from "react";
import styles from './styles.module.less';

type TAd = {
  ad_data?:{
    url: string
    href: string
  }
}

const Ad:React.FC<TAd> = ({ad_data}) => {
  return (
    <div className={styles.ad_wrapper}>
      {ad_data  ? (<a rel="noreferrer" target="_blank" href={ad_data.href}><img alt="" src={ad_data.url} className={styles.adimg}/></a>) : null}
    </div>
  )
}
export default Ad;
